import { logAPI } from "../andyliticsApi";
const webTpaApiUrl = typeof window !== 'undefined' ? window.serverData.data.webTPAUrl : ''; // window is undefined during pre-render
// this needs to be loaded dynamically (since it will change after startup)
//const hpServicesUrl = typeof window !== 'undefined' ? (window.serverData.data.hpServicesSpecificUrl ? window.serverData.data.hpServicesSpecificUrl : window.serverData.data.hpServicesUrl) : ''; // window is undefined during pre-render
import * as tools from "../../helpers/Tools";


export const getAuthorizationsList = (token, memId, startDate, endDate) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/Authorizations/member/'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memberId: memId,
            serviceStartDate: startDate,
            serviceEndDate: endDate
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Authorizations.GetAuthorizationsList", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.text().then(function (text) {
                return text ? JSON.parse(text) : []
            }));
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Authorizations.GetAuthorizationsList.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getAuthorizationDetail = (token, memId, authorizationHccId) => {
    const url = encodeURI( tools.buildUrl( tools.hpAPIBaseURL(), '/Authorizations/member/detail/'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memberId: memId,
            authorizationId: authorizationHccId,
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Authorizations.GetAuthorizationDetail", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.text().then(function (text) {
                return text ? JSON.parse(text) : []
            }));
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Authorizations.GetAuthorizationDetail.Failure", start, url, err); return Promise.reject(err);
    });
};